import { render } from "./CustomerList.vue?vue&type=template&id=1407934c&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=1407934c&scoped=true&lang=css"
import "./CustomerList.vue?vue&type=style&index=1&id=1407934c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1407934c"]])

export default __exports__